<div class="trial-screen">
    <div class="trial-screen-left">
        <div class="left-container">
            <div class="logo-container">
                <img [src]="'images/login-browsi-logo.png' | assetVersion" alt="Browsi Logo" class="logo">
                <span class="logo-text">InsightHub</span>
            </div>
            <div class="branding-content-container">
                <div class="headers-container">
                    <div class="header-title"> Outperform Your</div>
                    <span class="header-subtitle">Competitors' Ads</span>
                </div>
                <div class="branding-bullets-container">
                    <div class="bullet-item">
                        <img [src]="'svg/orange-eye-in-square.svg' | assetVersion" alt="Bullet Point" class="bullet-point">
                        <span class="bullet-text">See competitors' creatives, strategies, and market gaps side by side.</span>
                    </div>
                    <div class="bullet-item">
                        <img [src]="'svg/orange-polaris.svg' | assetVersion" alt="Bullet Point" class="bullet-point">
                        <span class="bullet-text">Turn complex competitive data into instant, actionable insights with POLARIS™ AI.</span>
                    </div>
                    <div class="bullet-item">
                        <img [src]="'svg/orange-graphs.svg' | assetVersion" alt="Bullet Point" class="bullet-point">
                        <span class="bullet-text">Powered by 50B ads analyzed monthly from real user behavior.</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="trial-screen-right">
        <img *ngIf="currentStep === TrialStep.REGISTER_EMAIL" 
             [src]="'images/browsi-logo-mobile.png' | assetVersion" 
             alt="Browsi Logo" 
             class="mobile-logo">
        <app-trial-step-indicator 
            *ngIf="currentStep > TrialStep.REGISTER_EMAIL && currentStep <= TrialStep.COMPLETE"
            [currentStep]="currentStep">
        </app-trial-step-indicator>
        <app-register-trial-email 
            *ngIf="currentStep === TrialStep.REGISTER_EMAIL"
            [firstNameControl]="firstNameControl"
            [lastNameControl]="lastNameControl"
            [emailControl]="emailControl"
            (nextStep)="onNextStep()">
        </app-register-trial-email>
        <div class="step-two-wrapper" *ngIf="currentStep === TrialStep.SELECT_BRAND">
            <app-trial-step-two 
                [firstName]="firstNameControl.value || ''"
                (nextStep)="onNextStep()">
            </app-trial-step-two>
        </div>
        <app-trial-step-three 
            *ngIf="currentStep === TrialStep.PROFILE" 
            [companyNameControl]="companyNameControl"
            [jobTitleControl]="jobTitleControl"
            [jobTitleItems]="jobTitleItems"
            [firstName]="firstNameControl.value || ''"
            (nextStep)="onNextStep()">
        </app-trial-step-three>
        <app-trial-step-four 
            *ngIf="currentStep === TrialStep.COMPLETE" 
            [firstName]="firstNameControl.value || ''"
            [email]="emailControl.value || ''"
            (nextStep)="onNextStep()">
        </app-trial-step-four>
    </div>
</div>

